import { DataTable } from 'mantine-datatable';
import { IconInbox } from '@tabler/icons-react';
import { TableProps } from './types';
import styles from './styles.module.css';

const EmptyState = () => (
  <div className={styles.emptyState}>
    <IconInbox size={36} stroke={1.2} className={styles.emptyIcon} />
    <span className={styles.emptyTitle}>Aucun résultat</span>
    <span className={styles.emptySubtext}>Il n'y a rien à afficher pour le moment.</span>
  </div>
);

const Table = <T extends object>(props: TableProps<T>) => {
  const { columns, data, rowKey, emptyState, ...rest } = props;

  return (
    <DataTable
      withTableBorder
      borderRadius="md"
      highlightOnHover
      horizontalSpacing="lg"
      verticalSpacing="sm"
      paginationWithEdges
      paginationSize="sm"
      emptyState={emptyState ?? <EmptyState />}
      classNames={{
        root: styles.root,
        header: styles.header,
        pagination: styles.pagination,
      }}
      {...(rest as any)}
      columns={columns}
      records={data}
      idAccessor={(rowKey || 'id') as any}
    />
  );
};

export type { ColumnType, TableProps, SortParams } from './types';
export default Table;
